const multiSelectImage =
    `<svg width="625px" height="625px" viewBox="0 0 625 625" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>multi select</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="multi-select">
            <rect id="backdrop-copy-3" stroke="#737373" stroke-width="12" fill="#FFFFFF" x="6" y="6" width="613" height="613" rx="135"></rect>
            <g id="row-copy-3" transform="translate(81, 427)" fill="#737373">
                <rect id="Rectangle" x="134" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-16" stroke="#737373" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
            <g id="row-copy-2" transform="translate(82, 277)">
                <rect id="Rectangle" fill-opacity="0.33" fill="#CFCECE" x="133" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-16" stroke-opacity="0.32659528" stroke="#CFCECE" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
            <g id="row-copy" transform="translate(81, 119)" fill="#737373">
                <rect id="Rectangle" x="134" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-17" stroke="#737373" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
        </g>
    </g>
</svg>`

const multiSelectImageHover =
    `<svg width="625px" height="625px" viewBox="0 0 625 625" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>multi select hover</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="multi-select-hover">
            <rect id="backdrop-copy-4" stroke="#737373" stroke-width="12" fill="#737373" x="6" y="6" width="613" height="613" rx="135"></rect>
            <g id="row-copy-3" transform="translate(81, 427)" fill="#FFFFFF">
                <rect id="Rectangle" x="134" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-16" stroke="#FFFFFF" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
            <g id="row-copy-2" transform="translate(82, 277)">
                <rect id="Rectangle" fill-opacity="0.33" fill="#CFCECE" x="133" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-16" stroke-opacity="0.33" stroke="#CFCECE" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
            <g id="row-copy" transform="translate(81, 119)" fill="#FFFFFF">
                <rect id="Rectangle" x="134" y="0" width="329" height="70"></rect>
                <rect id="Rectangle-Copy-17" stroke="#FFFFFF" stroke-width="12" x="6" y="6" width="58" height="58"></rect>
            </g>
        </g>
    </g>
</svg>`

export { multiSelectImage, multiSelectImageHover }
